import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Injects a `<meta name="robots" content="noindex, nofollow, noarchive">`
 * whenever the user navigates to a private route (client dashboard,
 * signup, admin, payment callback, preview). Removes it on public routes.
 * Also toggles a matching X-Robots-Tag on the document itself (best-effort).
 *
 * Public (indexable) routes: `/`, `/entreprise/:slug`.
 * Everything else is treated as private.
 */
const PRIVATE_PREFIXES = [
  "/mon-compte-client",
  "/signup",
  "/dashboard",
  "/auth/callback",
  "/payment/",
  "/preview/",
  "/apercu-modele/",
  "/admin",
  "/cgv",
  "/conditions-generales-de-vente",
  "/mentions-legales",
];

export default function RouteSEO() {
  const location = useLocation();
  useEffect(() => {
    const isPrivate = PRIVATE_PREFIXES.some((p) =>
      location.pathname.startsWith(p)
    );
    const META_ID = "robots-noindex-meta";
    const existing = document.getElementById(META_ID);
    if (isPrivate) {
      if (!existing) {
        const meta = document.createElement("meta");
        meta.id = META_ID;
        meta.name = "robots";
        meta.content = "noindex, nofollow, noarchive";
        document.head.appendChild(meta);
      }
    } else if (existing) {
      existing.remove();
    }
  }, [location.pathname]);
  return null;
}
